export default [
	{ value: 1, duration: 120, color: '#4a90e2', secondaryColor: '#4382cb', },
	{ value: 2, duration: 180, color: '#b8e986', secondaryColor: '#a6d279', },
	{ value: 5, duration: 300, color: '#f8e71c', secondaryColor: '#dfd019', },
	{ value: 10, duration: 600, color: '#f5a623', secondaryColor: '#dd9520', },
	{ value: 20, duration: 1200, color: '#bd10e0', secondaryColor: '#aa0eca', },
	{ value: 50, duration: 2400, color: '#9013fe', secondaryColor: '#8211e5', },
	{ value: 100, duration: 3600, color: '#d0021b', secondaryColor: '#bb0218', },
	{ value: 200, duration: 7200, color: '#d0021b', secondaryColor: '#bb0218', },
	{ value: 300, duration: 10800, color: '#d0021b', secondaryColor: '#bb0218', },
	{ value: 400, duration: 14400, color: '#d0021b', secondaryColor: '#bb0218', },
	{ value: 500, duration: 18000, color: '#d0021b', secondaryColor: '#bb0218', },
];
